angular.module('picmonicng').directive('autoExpand', [
  '$timeout',
  function ($timeout) {
    return {
      restrict: 'A',
      link: function (scope, element) {
        var tempContainer = angular.element(document.createElement('div'));
        tempContainer.addClass('auto-expand-temp');
        element.after(tempContainer);
        element.bind('keypress', function () {
          scope.$apply(function () {
            determineSize();
          });
        });

        function determineSize() {
          if (element.val()) {
            tempContainer.width(element.width());

            tempContainer.html(element.val());

            if (tempContainer.height() > 26) {
              element.height(tempContainer.height() + 15);
            } else {
              element.height(tempContainer.height());
            }
          }
        }

        $timeout(function () {
          determineSize();
        }, 10);
      },
    };
  },
]);
